(function () {
  const deleteColorSchemes = (element) => {
    element.classList.forEach((className) => {
      if (
        className.startsWith("color-background-") &&
        className != "color-background-overlay"
      ) {
        element.classList.remove(className);
      }
    });
  };

  // ✅ 新增：只初始化一次的移动端 drawer 链接兜底跳转
  const initMobileDrawerLinkFallback = () => {
    if (window.__lockinDrawerLinkFallbackInitialized) return;
    window.__lockinDrawerLinkFallbackInitialized = true;

    document.addEventListener(
      "click",
      function (e) {
        // 只处理移动端 drawer 内的真实链接
        const a =
          e.target && e.target.closest
            ? e.target.closest('#menu-drawer a[href]')
            : null;
        if (!a) return;

        const href = a.getAttribute("href");
        if (!href) return;

        // 忽略：占位链接 / JS 链接 / hash 锚点
        const trimmed = href.trim();
        if (
          trimmed === "#" ||
          trimmed.startsWith("javascript:") ||
          trimmed.startsWith("#")
        ) {
          return;
        }

        // 允许新开标签 / 新窗口（不强制接管）
        if (
          e.metaKey ||
          e.ctrlKey ||
          e.shiftKey ||
          e.altKey ||
          e.button === 1 ||
          a.getAttribute("target") === "_blank"
        ) {
          return;
        }

        // 如果其它脚本已经阻止了默认跳转，这里兜底强制跳
        // （即使没被阻止，强制跳也不会有副作用，但我们尽量只在需要时接管）
        // 注意：defaultPrevented 在 capture 阶段可能还没被置位，所以我们直接兜底接管。
        e.preventDefault();
        e.stopPropagation();

        // 关闭抽屉（外层 hamburger 是 header-drawer 的 details.menu-drawer-container）
        const outer = document.querySelector(
          "header-drawer details.menu-drawer-container"
        );
        if (outer) outer.removeAttribute("open");

        window.location.href = trimmed;
      },
      true // capture：抢先执行，绕过其它脚本的 preventDefault
    );
  };

  const header = () => {
    const header = document.querySelector(".shopify-section-header");
    const menu = document.querySelector(".list-menu--inline");
    const menuLinks = document.querySelectorAll(".list-menu-item");
    const search = document.querySelector("details-modal.header__search");
    const searchModal = document.querySelector(
      "details-modal.header__search > details"
    );
    const allSubmenu = document.querySelectorAll(".header__submenu");
    const isLightLogo =
      document
        .querySelector("main")
        .querySelectorAll(".shopify-section")[0]
        ?.querySelector("[data-header-transparent]")
        ?.getAttribute("data-header-light-logo") || "";
    const main = document.getElementById("MainContent");
    const sections = main.querySelectorAll(".shopify-section");
    const sectionFirstChildTransparent = sections[0]?.querySelector(
      "[data-header-transparent]"
    );
    const headerTransparent = header
      .querySelector(".header-wrapper")
      .classList.contains("header-wrapper--full-width");

    // ✅ 新增：初始化移动端 drawer 链接兜底（只做一次）
    initMobileDrawerLinkFallback();

    if (isLightLogo == "true") header.classList.add("header--light-logo");
    else header.classList.remove("header--light-logo");

    if (!(sectionFirstChildTransparent && headerTransparent)) {
      deleteColorSchemes(header);
      header.classList.remove("color-background-overlay");
    }

    header.addEventListener("keydown", (e) => {
      if (e.code === "Escape" && search && search.isOpen) {
        search.close();
      }
    });

    menuLinks.forEach((link) => {
      link.addEventListener("mouseenter", () => {
        if (link.classList.contains("list-menu--megamenu")) {
          link.classList.add("list-menu--megamenu-visible");
          document.querySelector(".header__overlay")?.classList.add("active");

          menuLinks.forEach((el) => {
            el.classList.add("list-menu-item--inactive");
            el.classList.remove("list-menu-item--active");
            if (el !== link) {
              el.classList.remove("list-menu--megamenu-visible");
            }
          });
          link.classList.remove("list-menu-item--inactive");
          link.classList.add("list-menu-item--active");
        } else {
          menuLinks.forEach((el) => {
            el.classList.add("list-menu-item--inactive");
            el.classList.remove("list-menu-item--active");
            el.classList.remove("list-menu--megamenu-visible");
            document.querySelector(".header__overlay")?.classList.remove("active");
          });
          link.classList.remove("list-menu-item--inactive");
          link.classList.add("list-menu-item--active");
        }
      });
    });

    document.body.addEventListener("mousedown", function () {
      document.body.classList.add("mouse-focus");
    });

    document.body.addEventListener("keydown", function (e) {
      if (e.key === "Tab") {
        document.body.classList.remove("mouse-focus");
      }
    });

    allSubmenu.forEach((submenu) => {
      const links = submenu.querySelectorAll(
        ".header__submenu-item:not(.header__submenu-item--grandchild)"
      );

      links.forEach((link) => {
        const childLinks = link.parentElement.querySelectorAll(
          ".header__submenu-item--grandchild"
        );

        link.addEventListener("mouseenter", () => {
          links.forEach((el) => {
            el.classList.add("header__submenu-item--inactive");
          });
          link.classList.remove("header__submenu-item--inactive");
        });

        childLinks.forEach((childLink) => {
          childLink.addEventListener("mouseenter", () => {
            childLinks.forEach((el) => {
              el.classList.add("header__submenu-item--inactive");
            });
            childLink.classList.remove("header__submenu-item--inactive");
          });
        });

        link.addEventListener("mouseleave", () => {
          childLinks.forEach((el) => {
            el.classList.remove("header__submenu-item--inactive");
          });
        });
      });

      submenu.addEventListener("mouseleave", () => {
        links.forEach((el) => {
          el.classList.remove("header__submenu-item--inactive");
        });
      });
    });

    menu?.addEventListener("mouseleave", () => {
      menuLinks.forEach((link) => {
        link.classList.remove("list-menu-item--inactive");
        link.classList.remove("list-menu-item--active");
        link.classList.remove("list-menu--megamenu-visible");
        document.querySelector(".header__overlay")?.classList.remove("active");
      });

      document.querySelectorAll(".header__submenu-item").forEach((link) => {
        link.classList.remove("header__submenu-item--inactive");
      });
    });

    if (header && header.classList.contains("color-background-overlay")) {
      const colorScheme = document
        .querySelector("main")
        .querySelectorAll(".shopify-section")[0]
        ?.querySelector("[data-header-transparent]")
        ?.getAttribute("data-header-transparent-color-scheme");

      header.addEventListener("mouseenter", () => {
        header.classList.remove("color-background-overlay");
        deleteColorSchemes(header);
        header.classList.add("color-background-overlay-hidden");
      });

      header.addEventListener("mouseleave", () => {
        if (!searchModal || !searchModal.hasAttribute("open")) {
          if (
            !header.classList.contains("shopify-section-header-sticky") &&
            !header.classList.contains("shopify-section-header-scroll") &&
            !header
              .querySelector(".menu-drawer-container")
              ?.classList.contains("menu-opening")
          ) {
            const main = document.getElementById("MainContent");
            const sections = main.querySelectorAll(".shopify-section");
            const sectionFirstChildTransparent = sections[0].querySelector(
              "[data-header-transparent]"
            );
            const headerTransparent = header
              .querySelector(".header-wrapper")
              .classList.contains("header-wrapper--full-width");

            if (sectionFirstChildTransparent && headerTransparent) {
              header.classList.add("color-background-overlay");
              if (colorScheme) header.classList.add(colorScheme);
            }
            header.classList.remove("color-background-overlay-hidden");
          }
        }
      });
    }

    if (header.querySelector(".header__submenu-button")) {
      header
        .querySelector(".js-open-list-menu-item")
        ?.addEventListener("click", (event) => {
          const submenu = event.currentTarget.closest(".header__submenu");
          const items = submenu.querySelectorAll(".header__submenu-li");
          if (items) {
            items.forEach((item) => {
              item.classList.add("active");
            });
          }

          event.currentTarget.parentElement.classList.add("hide");
        });
    }
  };

  document.addEventListener("shopify:section:load", header);
  document.addEventListener("shopify:section:unload", header);
  document.addEventListener("shopify:section:reorder", header);

  header();
})();
